@if (loading) {
  <div class="page-loader spinner">
    <mat-spinner></mat-spinner>
  </div>
} @else {
  <div class="container">
    <h2 mat-dialog-title>
      @if (readOnly) {
        Detalhes do Médico
      } @else {
        Editar Médico
      }
    </h2>

    <div class="doctor-details">
      <!-- Dados Pessoais -->
      <mat-accordion class="example-headers-align" multi>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Lista de Desejos de Produtos</mat-panel-title>
          </mat-expansion-panel-header>
          @if (wishlistLoading) {
            <p role="status">Carregando lista de desejos…</p>
          } @else if (wishlistError) {
            <p role="alert">Não foi possível consultar a lista de desejos.</p>
            <button mat-button type="button" (click)="loadWishlist()">Tentar novamente</button>
          } @else {
            <h3>Produtos sinalizados</h3>
            <ul>
              @for (interest of activeWishlist; track interest.id) {
                <li>{{ interest.nome }} — {{ interest.sinalizado_em | date:'dd/MM/yyyy':'-0300' }}</li>
              } @empty {
                <li>Nenhum produto sinalizado atualmente.</li>
              }
            </ul>
            <h3>Histórico de ações da lista de desejos</h3>
            <ul>
              @for (action of wishlistActions; track action.id) {
                <li>{{ action.em | date:'dd/MM/yyyy HH:mm:ss':'-0300' }} — {{ action.acao }} — {{ action.produto }}</li>
              } @empty {
                <li>Nenhuma ação registrada.</li>
              }
            </ul>
          }
        </mat-expansion-panel>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon>account_circle</mat-icon>
              Dados Pessoais
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="section">
            <div class="fields-grid">
              <mat-form-field appearance="outline">
                <mat-label>Data cadastro/optin</mat-label>
                <input matInput [value]="doctor.data_cadastro" [readonly]="true" />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>CPF</mat-label>
                <input matInput [value]="doctor.cpf" [readonly]="true" />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Nome</mat-label>
                <input matInput [value]="doctor.nome" [readonly]="true" />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Email</mat-label>
                <input matInput [value]="doctor.email" [readonly]="true" />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Telefone</mat-label>
                <input matInput [value]="doctor.telefone" [readonly]="true" />
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon>wallet</mat-icon>
              Dados Profissionais
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="section">
            <div class="fields-grid">
              <mat-form-field appearance="outline">
                <mat-label>CRM</mat-label>
                <input matInput [value]="doctor.crm" [readonly]="true" />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>UF</mat-label>
                <input matInput [value]="doctor.uf" [readonly]="true" />
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Especialidades Auto-declaração</mat-label>
                <textarea
                  matInput
                  [value]="doctor.especialidades"
                  [readonly]="true"
                  rows="3"
                ></textarea>
              </mat-form-field>

              <mat-form-field appearance="outline">
                <mat-label>Especialidades CFM</mat-label>
                <textarea
                  matInput
                  [value]="doctor.especialidades_cfm"
                  [readonly]="true"
                  rows="3"
                ></textarea>
              </mat-form-field>
            </div>
          </div>
        </mat-expansion-panel>

        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              <mat-icon>sell</mat-icon>
              Pedidos
            </mat-panel-title>
            <span
              class="status-badge"
              [ngClass]="doctor.ja_resgatou === 'Sim' ? 'status-solicitado' : 'status-default'"
              >{{ doctor.ja_resgatou === 'Sim' ? 'Já solicitado' : 'Não possui' }}</span
            >
          </mat-expansion-panel-header>

          <div class="">
            @if (doctor.ja_resgatou === 'Sim') {
              @for (pedido of doctor.pedidos; track $index) {
                <mat-expansion-panel>
                  <mat-expansion-panel-header>
                    <mat-panel-title class="justify-between">
                      <span>Pedido {{ pedido.pedido_numero }}</span>
                      <span class="status-badge" [ngClass]="getStatusClass(pedido.pedido_status)">{{
                        pedido.pedido_status
                      }}</span>
                    </mat-panel-title>
                  </mat-expansion-panel-header>
                  <div class="fields-grid">
                    @for (historico of pedido.historico; track $index) {
                      <div>
                        <mat-panel-title class="justify-between">
                          <span class="history-caption"
                            >Atualizado em {{ formatDate(historico.atualizacao) }}
                            <span
                              class="status-badge"
                              [ngClass]="getStatusClass(historico.status)"
                              >{{ historico.status }}</span
                            >
                          </span>
                        </mat-panel-title>
                        <span class="history-caption">{{
                          historico.comunicado_por_email
                            ? '✉️ Disparo de email realizado'
                            : 'Não comunicado'
                        }}</span>
                        <hr style="color: gainsboro !important" />
                      </div>
                    }
                    <mat-form-field appearance="outline">
                      <mat-label>Data de aceite</mat-label>
                      <input matInput [value]="pedido.pedido_data" [readonly]="true" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Data do pedido</mat-label>
                      <input matInput [value]="pedido.pedido_data" [readonly]="true" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Número do pedido</mat-label>
                      <input matInput [value]="pedido.pedido_numero" [readonly]="true" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Produto</mat-label>
                      <input matInput [value]="pedido.pedido_produto" [readonly]="true" />
                    </mat-form-field>

                    <mat-form-field appearance="outline">
                      <mat-label>Status</mat-label>
                      <input matInput [value]="pedido.pedido_status" [readonly]="true" />
                    </mat-form-field>

                    <button
                      mat-stroked-button
                      class="clear-btn"
                      (click)="goToOrder(pedido.pedido_data, pedido.pedido_numero)"
                    >
                      <mat-icon>visibility</mat-icon>
                      Ver pedido
                    </button>
                  </div>
                </mat-expansion-panel>
              }
            } @else {
              <p class="no-order">Não possui pedido</p>
            }
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <!-- Status -->
      <div class="section">
        <h3>Status</h3>
        <div class="fields-grid">
          <mat-form-field appearance="outline">
            <mat-label>Status do Médico</mat-label>
            <mat-select [(value)]="doctor.status" [disabled]="!isFieldEditable('status')">
              <mat-option [value]="true">Liberado</mat-option>
              <mat-option [value]="false">Bloqueado</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>

    <div mat-dialog-actions class="actions">
      @if (isFieldEditable('status')) {
        <button (click)="save()" class="save-btn" mat-raised-button color="primary">
          <mat-icon>save</mat-icon>
          Salvar Alterações
        </button>
      }

      <button (click)="cancel()" class="cancel-btn" mat-stroked-button>
        <mat-icon>close</mat-icon>
        Fechar
      </button>
    </div>
  </div>
}
